import moment from 'moment';

/* prefer the server's is_current flag; fall back to comparing the event window to now */
export const computeIsCurrent = (ticket, event = {}) => {
  if (typeof ticket.is_current === 'boolean') {
    return ticket.is_current;
  }
  const start = event.start_time || ticket.event_start_time;
  if (!start) {
    return false;
  }
  const end = event.end_time || ticket.event_end_time;
  const now = moment();
  const started = now.isSameOrAfter(moment(start));
  const ended = end ? now.isAfter(moment(end)) : false;
  return started && !ended;
};

/* the ticket payload shape isn't confirmed yet - normalization is centralized here so the
   list and per-event screens read the same fields */
export const normalizeTicket = (ticket) => {
  const event = ticket.event || {};
  return {
    uuid: ticket.uuid || ticket.id,
    eventId: event.id != null ? event.id : ticket.event_id,
    eventName: event.name || ticket.event_name,
    tierName: ticket.tier_name || ticket.ticket_tier_name || ticket.tier?.name,
    startTime: event.start_time || ticket.event_start_time,
    venueName: event.venue_name || ticket.venue_name,
    venueAddress: event.venue_address || ticket.venue_address,
    image: event.primary_image || ticket.primary_image,
    isCurrent: computeIsCurrent(ticket, event),
    ticketCode: ticket.ticket_code,
    qrCode: ticket.qr_code || ticket.ticket_code,
    status: ticket.status,
    pricePaid: ticket.price_paid,
    purchasedAt: ticket.created_at,
    checkedInAt: ticket.checked_in_at,
    orderReference: ticket.order?.reference,
    bundledRewards: ticket.tier?.bundled_rewards || [],
    raw: ticket,
  };
};

export const normalizeEventTickets = (event = {}) =>
  (event.tickets || []).map((ticket) =>
    normalizeTicket({ ...ticket, event: ticket.event || event }),
  );
